// Enums
import { MediaRequestType } from "./types.js"; // Types
export default class MediaRequest {
  constructor(formats) {
    this.formats = void 0;
    this.type = void 0;
    this.formats = formats;
    this.type = MediaRequestType.FULL;
  }
}
//# sourceMappingURL=MediaRequest.js.map